// A page for people signed in to a pool: anyone else goes to sign in first, and comes back to it.
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from './auth';
import { signInPath } from './auth/next';
import type { Pool } from './config';
import { Spinner } from './ui';

export function RequireSignIn({ pool, children }: { pool: Pool; children: ReactNode }) {
  const auth = useAuth();
  const location = useLocation();
  if (auth.signingOut(pool)) {
    return (
      <div className="page-waiting">
        <Spinner size="large" label="Signing you out" />
      </div>
    );
  }
  if (!auth.session(pool)) {
    return <Navigate to={signInPath(pool, `${location.pathname}${location.search}${location.hash}`)} replace />;
  }
  return children;
}
